import ConsentForm from './components/ConsentForm'

const Consent = () => {
    return (
        <div className="fixed inset-x-0 top-16 bottom-0 flex justify-center items-stretch bg-gray-50 dark:bg-gray-900 px-2 sm:px-3 md:px-4 lg:px-6 xl:px-8 2xl:px-10 min-[2560px]:px-16 py-2 sm:py-2 md:py-3 lg:py-4 xl:py-5 2xl:py-6 min-[2560px]:py-10 overflow-hidden">
            <div className="w-full max-w-[480px] sm:max-w-[640px] md:max-w-[880px] lg:max-w-[1040px] xl:max-w-[1200px] 2xl:max-w-[1360px] min-[2560px]:max-w-[1800px] bg-white dark:bg-gray-800 rounded-lg sm:rounded-xl lg:rounded-2xl min-[2560px]:rounded-3xl shadow-sm border border-gray-100 dark:border-gray-700 flex flex-col overflow-hidden min-h-0">
                <div className="flex flex-col items-center px-3 sm:px-4 md:px-6 lg:px-8 xl:px-10 2xl:px-12 min-[2560px]:px-20 pt-2 sm:pt-3 md:pt-4 lg:pt-4 xl:pt-5 2xl:pt-6 min-[2560px]:pt-10 pb-2 sm:pb-2 md:pb-3 lg:pb-3 xl:pb-3 2xl:pb-4 min-[2560px]:pb-8 border-b border-gray-100 dark:border-gray-700 shrink-0">
                    <img
                        className="h-7 sm:h-8 md:h-10 lg:h-11 xl:h-12 2xl:h-14 min-[2560px]:h-24 w-auto object-contain"
                        src="/portal/img/logo/oasys-logo.png"
                        alt="OASYS"
                    />
                    <h4 className="mt-1 sm:mt-1.5 md:mt-1.5 lg:mt-2 xl:mt-2 2xl:mt-2.5 min-[2560px]:mt-4 text-center font-semibold text-sm sm:text-base md:text-base lg:text-lg xl:text-lg 2xl:text-xl min-[2560px]:text-4xl leading-tight">
                        Before You Continue
                    </h4>
                    <p className="mt-0.5 sm:mt-1 md:mt-1 lg:mt-1 xl:mt-1.5 2xl:mt-1.5 min-[2560px]:mt-3 text-center text-[10px] sm:text-[11px] md:text-xs lg:text-xs xl:text-sm 2xl:text-sm min-[2560px]:text-2xl text-gray-500 dark:text-gray-400 leading-snug px-2">
                        Please review and accept the following to continue using the portal.
                    </p>
                </div>
                <ConsentForm />
            </div>
        </div>
    )
}

export default Consent
